import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const emailRef = useRef(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    // Auto-focus the email input the moment the user lands on /login
    emailRef.current?.focus();
    // Also scroll the form into view (mobile safari fix)
    document.getElementById("signin-form")?.scrollIntoView({ block: "center" });
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      nav("/dashboard");
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24 bg-[#0A0C10] grain-bg">
      <div className="w-full max-w-md fade-up" id="signin-form">
        <Link to="/" className="block text-center overline mb-3" data-testid="back-home">
          ← Back to home
        </Link>
        <div className="glass-card p-10">
          <h1 className="font-display text-4xl text-center">Welcome back</h1>
          <p className="text-slate-400 text-center mt-2 text-sm">
            Sign in to enter the society.
          </p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="overline block mb-2">Email</label>
              <input
                ref={emailRef}
                type="email"
                required
                className="input-dark"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="composer@example.com"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input
                type="password"
                required
                className="input-dark"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>
            {err && (
              <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2" data-testid="login-error">
                {err}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              className="btn-gold w-full disabled:opacity-50"
              data-testid="login-submit-btn"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-center text-sm text-slate-400 mt-6">
            New here?{" "}
            <Link to="/register" className="text-[#7DA3D9] hover:text-[#B8D0EE]" data-testid="goto-register">
              Join the society
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
